import { FC, Fragment } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';

import { Transition, animated, config } from '@react-spring/web';

const ModalBox = styled.div`
  border-radius: 8px;
  padding: 16px;
`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: bold;
  margin-top: 0;
  user-select: none;
`;

export const ScoreValue = styled.h1`
  font-size: 30px;
  margin-top: 0px;
  font-weight: bolder;
  color: #713413;
  user-select: none;
`;

export const Window: FC<{ show: boolean; bshow: boolean; backdropOnClick?: () => void ; itemOnClick?: () => void }> =
  ({ children, show, bshow, backdropOnClick, itemOnClick }) => {
    const AppContainer = document.querySelector('.App');

    const handleBackdropOnClick = () => {
      backdropOnClick && backdropOnClick();
    };

    const doClick = () => {
      itemOnClick && itemOnClick();
    };

    // 親要素のDOM階層の外に追加
    return ReactDOM.createPortal(
      <Fragment>
        <div
          style={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClick={doClick}
        >
          <Transition
            items={show}
            config={config.wobbly}
            from={{ scale: 1, opacity: 0 }}
            enter={{ scale: 1, opacity: 1 }}
            leave={{ scale: 1, opacity: 0 }}
          >
            {({ scale, opacity }, item) =>
              item && (
                <animated.div
                  style={{
                    scale,
                    opacity,
                    width: '100%',
                    zIndex: 300,
                    padding: 16,
                    pointerEvents: 'auto',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',                  }}
                >
                  <ModalBox>{children}</ModalBox>
                </animated.div>
              )
            }
          </Transition>
        </div>
        {show && !bshow && (
          <div
            style={{
              position: 'absolute',
              zIndex: 200,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
            }}
            onClick={handleBackdropOnClick}
          />
        )}
      </Fragment>,
      AppContainer!
    );
  };
